// extracted by mini-css-extract-plugin
export default {"container":"UX6c91","form":"O7jUZH"};